<script setup>
import { computed } from "vue";

const props = defineProps({
  items: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  meta: { type: Object, default: () => ({}) },
});

const emit = defineEmits(["page-change"]);

const columns = [
  { sorter: false },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: {
      compare: (a, b) =>
        (a.name || "").toLowerCase() > (b.name || "").toLowerCase() ? 1 : -1,
    },
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "Role",
    dataIndex: "role",
    key: "role",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Created",
    dataIndex: "created_at",
    key: "created_at",
  },
];

const dataSource = computed(() =>
  props.items.map((u) => ({
    key: u.id,
    id: u.id,
    name: u.name,
    email: u.email,
    avatar: u.avatar,
    role: u.role,
    status: u.status,
    created_at: u.created_at,
  }))
);

const pagination = computed(() => ({
  current: props.meta.current_page || 1,
  pageSize: props.meta.per_page || 25,
  total: props.meta.total || 0,
  showSizeChanger: false,
  onChange: (page) => emit("page-change", page),
}));
</script>

<template>
  <a-table
    class="dq-report-table"
    :columns="columns"
    :data-source="dataSource"
    :loading="loading"
    :pagination="pagination"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'name'">
        <div class="d-flex align-items-center">
          <img
            :src="record.avatar"
            class="avatar avatar-md me-2"
            alt="avatar"
          />
          <span>{{ record.name }}</span>
        </div>
      </template>

      <template v-if="column.key === 'status'">
        <span
          class="badge"
          :class="record.status === 'Active' ? 'badge-success' : 'badge-danger'"
        >
          {{ record.status }}
        </span>
      </template>
    </template>
  </a-table>
</template>

<style scoped>
@media (max-width: 767.98px) {
  :deep(.dq-report-table .ant-table) {
    min-width: 920px;
  }

  :deep(.dq-report-table .ant-table-cell) {
    vertical-align: top;
    white-space: normal;
  }
}
</style>
